import { setUserPermissions } from './set-user-permissions';

/** `PUT /client/:cid/users/:id/permissions {administrator: true}`. */
export const grantAdminAccess = async (user_id: string): Promise<any> =>
  setUserPermissions(user_id, { administrator: true });
